<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->
    
    <!-- View License -->
    <transition name="popup">
      <PCContractAccountViewLicense
        v-if="state.visibleViewLicense"
        @closeViewLicense="state.visibleViewLicense = false"
      />
    </transition>

    <!-- Administrator Transfer Popup -->
    <transition name="popup">
      <PCContractAdministratorTransfer
        v-if="state.visibleAdminTransfer"
        @close="state.visibleAdminTransfer = false"
        @submit="action.adminSubmit"
      />
    </transition>

    <!-- Reset Popup -->
    <transition name="popup">
      <PCContractAccountReset
        v-if="state.visibleReset"
        @close="action.resetClose"
        @submit="action.resetSubmit"
      />
    </transition>

    <!-- Detail Popup -->
    <transition name="popup">
      <PCContractAccountDetail
        v-if="state.visibleDetail"
        @close="state.visibleDetail = false"
        @openEdit="state.visibleDetail = false, state.visibleEdit = true"
      />
    </transition>

    <!-- Create Popup -->
    <transition name="popup">
      <PCContractAccountCreate
        v-if="state.visibleCreate"
        @closeCreate="state.visibleCreate = false"
        @submit="action.createSubmit"
      />
    </transition>

    <!-- Edit Popup -->
    <transition name="popup">
      <PCContractAccountEdit
        v-if="state.visibleEdit"
        @closeEdit="state.visibleEdit = false"
        @openAdminPopup="state.visibleEdit = false, state.visibleAdminTransfer = true"
        @submit="action.editSubmit"
      />
    </transition>

    <!-- 停止 -->
    <transition name="popup">
      <PCContractAccountStop
        v-if="state.visibleContractAccountStop"
        @close="action.stopClose"
        @submit="action.stopSubmit"
      />
    </transition>


    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="contract" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="contract-head">
            <h1 class="hdg03">利用者アカウント管理</h1>
          </div>
          <form v-if="state.initialize" @submit.prevent="action.search" class="contract-container">
            <div class="contract-content">
              <p class="txt">利用者アカウントの追加・変更が可能です。<br>追加したアカウントにライセンスを付与する場合は、ライセンス管理よりアカウント名にチェックをいれてください。</p>

              <div class="license-hdg">
                <h2 class="license-hdg-title hdg03">利用者アカウント</h2>
                <div class="license-hdg-aside">
                  <router-link to="/pc/contract-account/bulk" class="box02-hdg-aside-menu">アカウントの一括登録・更新はこちら​</router-link>
                </div>
              </div>
              
              <div class="contract-content-search">
                <div class="formparts search">
                  <FontawesomeIcon @click="action.search" :icon="['far','search']" size="2x" class="icn" />
                  <input type="text" placeholder="アカウント名" v-model="state.searchKeyword">
                </div>
                <p class="contract-content-search-register">
                  <span v-if="!state.accountIsMax" class="txt-blue" @click="state.visibleCreate = true" role="button">新規アカウントの追加</span>
                </p>
              </div>
              <div class="contract-content-info">
                <p v-if="state.accountIsMax" class="contract-content-info-notice">これ以上、ご利用アカウントを増やすことができません。<br>既存のアカウントをリセットするか、新しくライセンスを購入してください。</p>
                <div class="contract-content-info-num">
                  <div class="contract-content-info-num-hdg">
                    <p>利用アカウント数</p>
                    <p class="contract-content-info-num-hdg-txt"><span :class="{max: state.accountIsMax }">{{contract.account_number}}</span> / <span>{{contract.account_number_max}}</span></p>
                    <p>最大アカウント数</p>
                  </div>
                </div>
              </div>
              <div class="tbl01 contract-content-table">
                <!-- <table class="tbl fixed-header"> -->
                <table class="tbl">
                  <thead>
                    <tr>
                      <th class="w32">アカウント名</th>
                      <th class="w12 ta-center">権限</th>
                      <th class="w12 ta-center">状態</th>
                      <th class="w20 ta-center">ライセンス付与数</th>
                      <th class="w24 ta-right">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in filterdUser" :key="index">
                      <td class="w32">
                        <span class="txt-blue" @click="action.viewDetail(user.id)"  role="button">{{user.name}}</span>
                      </td>
                      <td class="w12 ta-center">{{user.auth === 0 ? '利用者' : '管理者'}}</td>
                      <td class="w12 ta-center">{{user.status === 1 ? '有効' : '停止'}}</td>
                      <td class="w20 ta-center">
                        <span v-if="user.products.length <= 0">{{user.products.length}}</span>
                        <span v-else class="txt-blue" @click="action.viewLicense(user.id)" role="button">{{user.products.length}}</span>
                      </td>
                      <td v-if="user.auth !== 0" class="w24 ta-right">&nbsp;</td>
                      <td v-else-if="user.status === 1" class="w24 ta-right">
                        <span class="txt-blue" @click="action.stop(user.id)" role="button">停止</span>
                      </td>
                      <td v-else class="w24 ta-right">
                        <span class="txt-blue" @click="action.reset(user.id)" role="button">リセット</span>
                        <span class="txt-blue" @click="action.start(user.id)" role="button">開始</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="filterdUser.length <= 0" class="contract-content-info-nothing">アカウントが見つかりません</p>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAccount } from '@/logic/contract/ContractAccount'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCContractAccountViewLicense from '@/components/pc/popup/PCContractAccountViewLicense.vue'
import PCContractAccountReset from '@/components/pc/popup/PCContractAccountReset.vue'
import PCContractAccountDetail from '@/components/pc/popup/PCContractAccountDetail.vue'
import PCContractAccountCreate from '@/components/pc/popup/PCContractAccountCreate.vue'
import PCContractAccountEdit from '@/components/pc/popup/PCContractAccountEdit.vue'
import PCContractAdministratorTransfer from '@/components/pc/popup/PCContractAdministratorTransfer.vue'
import PCContractAccountStop from '@/components/pc/popup/PCContractAccountStop.vue'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu,
    PCContractAccountViewLicense,
    PCContractAccountReset,
    PCContractAccountDetail,
    PCContractAccountCreate,
    PCContractAccountEdit,
    PCContractAdministratorTransfer,
    PCContractAccountStop
  },
  setup (props, context) {
    return { ...ContractAccount(context) }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.contract {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .license {
      &-hdg {
        position: relative;
        margin-bottom: 14px;
        &-title {
          margin-bottom: 0;
        }
        &-aside {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate3d(0, -50%, 0);
          a {
            padding-right: 0;
          }
        }
      }
    }
    .txt {
      line-height: 1.625;
    }
    .hdg03 {
      margin: 62px 0 30px;
      padding-bottom: 14px;
      border-bottom: 1px solid $color-line;
    }
    &-search {
      display: table;
      table-layout: fixed;
      width: 100%;
      .formparts.search {
        display: table-cell;
        vertical-align: middle;
        width: calc(100% - 180px);
        input[type=text]{
          height: 48px;
        }
      }
      &-register {
        display: table-cell;
        vertical-align: middle;
        width: 180px;
        font-size: 1.4rem;
        text-align: right;
      }
    }
    &-info {
      display: table;
      table-layout: fixed;
      width: 100%;
      margin: 28px 0 20px;
      &-notice {
        display: table-cell;
        vertical-align: bottom;
        font-size: 1.4rem;
        line-height: 1.57;
        color: $color-sup;
      }
      &-nothing {
        color: #999999;
        text-align: center;
        padding: 40px;
      }
      &-num {
        display: table-cell;
        vertical-align: bottom;
        text-align: right;
        padding: 0 18px;
        line-height: 1.57;
        &-hdg {
          display: flex;
          color: $color-sup;
          align-items: center;
          font-size: 1.4rem;
          float: right;
          p {
            margin-left: 12px;
          }
          &-txt {
            font-size: 2rem;
            color: $color-hdg;
            font-weight: bold;
            line-height: 1.1;
            margin-top: -3px;
            .max {
              color: $color-highlight;
            }
          }
        }
      }
      
    }
    &-table{
      overflow-y: auto;
      thead{
        th{
          background: $color-bg-paper;
          border-bottom: 0;
        }
      }
      tbody{
        td{
          span.txt-blue + span.txt-blue{
            margin-left: 35px;
            padding-left: 20px;
            border-left: 1px solid rgba(153, 153, 153, 0.2);
          }
        }
      }
    }
  }
}
.fixed-header {
  tbody {
    display: block;
    max-height: 330px;
    overflow-y: scroll;
  }
  thead,
  tbody tr {
    display: table;
    width: 100%;
  }
}
</style>
